
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.57 6.23a.821.821 0 10.23.57.81.81 0 00-.23-.57zm0 2.4a.8.8 0 00-1.37.57v4a.8.8 0 101.6 0v-4a.81.81 0 00-.23-.57zM10 8.4a.786.786 0 00-.8.8v4a.8.8 0 101.6 0v-4a.786.786 0 00-.8-.8zm0-.8a.786.786 0 10-.57-.23.81.81 0 00.57.23zm0 .8a.786.786 0 00-.8.8v4a.8.8 0 101.6 0v-4a.786.786 0 00-.8-.8zm0-.8a.786.786 0 10-.57-.23.81.81 0 00.57.23z"}}),_c('path',{attrs:{"d":"M10 2a8 8 0 108 8 8 8 0 00-8-8zm0 14.643A6.643 6.643 0 1116.643 10 6.644 6.644 0 0110 16.643z"}})])
          )
        }
      }
    